import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import * as Ant from "antd";
import { useTranslate } from "@bluelibs/x-ui";
import { SmileOutlined } from "@ant-design/icons";
import { ApolloError, useMutation } from "@apollo/client";
import { UpdateBankAccountBalance } from "@bundles/UIAppBundle/mutations/UpdateBankAccountBalance";
const BankAccountBalanceInput = ({ model }) => {
    const t = useTranslate();
    const [isInput, setIsInput] = useState(false);
    const [balance, setBalance] = useState(model.initialBalance);
    const [updataBalance] = useMutation(UpdateBankAccountBalance);
    const handleSave = () => {
        updataBalance({
            variables: {
                input: {
                    bankAccountId: model._id,
                    balance,
                },
            },
        })
            .then(() => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.bank_accounts.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            setIsInput(false);
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    };
    return isInput ? (_jsxs("div", Object.assign({ className: "bank-account-balance-input-container" }, { children: [_jsx(Ant.InputNumber, { defaultValue: model.initialBalance, onChange: (e) => setBalance(e), onKeyUp: (e) => {
                    if (e.key === "Enter") {
                        handleSave();
                    }
                } }, void 0), _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "button", onClick: handleSave }, { children: t("management.bank_accounts.save") }), void 0)] }), void 0)) : (_jsx("p", Object.assign({ className: "bank-account-balance-input-container-text", onClick: () => setIsInput(!isInput) }, { children: `${(balance !== null && balance !== void 0 ? balance : 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}` }), void 0));
};
export default BankAccountBalanceInput;
